<template>
    <v-container class="ma-0 pa-0 pb-8">
        <v-row class="pt-10 px-8 pb-12">
            <strong>Filtros</strong>
            <v-spacer></v-spacer>
            <v-btn @click="removeFilter()" small class="elevation-0" style="border:solid 1px #dddddd;">
                <v-icon small class="mr-1">mdi-filter-off</v-icon>Limpiar
            </v-btn>

            <v-text-field label="Folio" v-model="quotation.id"></v-text-field>
            
            <!--v-autocomplete v-model="quotation.influencer" :items="influencerLists" multiple chips :loading="isLoadingInfluencers" :search-input.sync="searchInfluencers" hide-no-data item-value="id" item-text="name" label="Influencer" placeholder="Escribe para buscar">
                <template slot="no-data"><div class="px-4 py-1">No existen influencers relacionadas.</div></template>  
            </v-autocomplete-->

            <v-select label="Estatus Campaña" v-model="quotation.campaign_status" :items="campaign_statuses" item-value="value" item-text="value"></v-select>

            <!--v-autocomplete v-model="quotation.agency" :items="agencyLists" multiple chips :loading="isLoadingAgencies" :search-input.sync="searchAgencies" hide-no-data item-value="id" item-text="name" label="Agencia(s)" placeholder="Escribe para buscar">
                <template slot="no-data"><div class="px-4 py-1">No existen agencias relacionadas.</div></template>  
            </v-autocomplete-->

            <v-autocomplete v-model="quotation.brand" :items="brandLists" multiple chips :loading="isLoadingBrands" :search-input.sync="searchBrands" hide-no-data item-value="id" item-text="name" label="Marca(s)" placeholder="Escribe para buscar">
                <template v-slot:item="{item, attrs, on}">
                    <v-list-item v-on="on" v-bind="attrs">
                        <v-list-item-content>
                            <v-list-item-title>
                                {{item.name}}
                            </v-list-item-title>
                            <v-list-item-subtitle>
                                {{item.agency.name}}
                            </v-list-item-subtitle>
                        </v-list-item-content>
                    </v-list-item>
                </template> 
            </v-autocomplete>

            <v-text-field label="Campaña" v-model="quotation.campaign"></v-text-field>

            <v-text-field label="Servicio" v-model="quotation.service"></v-text-field>       

            <v-text-field label="Fecha de servicio" v-model="quotation.service_date"></v-text-field>

            <!--v-autocomplete v-model="quotation.user_id" :items="userList" hide-no-data item-value="id" item-text="name" label="Responsable Kams" placeholder="Escribe para buscar" attach chips multiple></v-autocomplete-->

            <v-menu offset-y :close-on-content-click="closeDatePicker(quotation.created_between)">
                <template v-slot:activator="{ on, attrs }">
                    <v-text-field clearable v-model="quotation.created_between" label="Fecha de Creación" prepend-icon="mdi-calendar" v-bind="attrs" readonly v-on="on"></v-text-field>
                </template>
                <v-date-picker v-model="quotation.created_between" range></v-date-picker>
            </v-menu> 

            <v-text-field label="Factura" v-model="quotation.invoice"></v-text-field>
            
            <v-select label="Factura Marca Adjunta" v-model="quotation.peach_invoice_file" item-value="value" item-text="text" :items="siyno"></v-select>

            <v-menu offset-y :close-on-content-click="closeDatePicker(quotation.invoice_date)">
                <template v-slot:activator="{ on, attrs }">
                    <v-text-field clearable v-model="quotation.invoice_date" label="Fecha Factura" prepend-icon="mdi-calendar" v-bind="attrs" readonly v-on="on"></v-text-field>
                </template>
                <v-date-picker v-model="quotation.invoice_date" range></v-date-picker>
            </v-menu>

            <v-menu offset-y :close-on-content-click="closeDatePicker(quotation.deadline_date)">
                <template v-slot:activator="{ on, attrs }">
                    <v-text-field clearable v-model="quotation.deadline_date" label="Fecha Cierre" prepend-icon="mdi-calendar" v-bind="attrs" readonly v-on="on"></v-text-field>
                </template>
                <v-date-picker v-model="quotation.deadline_date" range></v-date-picker>
            </v-menu>

            <v-menu offset-y :close-on-content-click="closeDatePicker(quotation.pay_date)">
                <template v-slot:activator="{ on, attrs }">
                    <v-text-field clearable v-model="quotation.pay_date" label="Fecha Pago" prepend-icon="mdi-calendar" v-bind="attrs" readonly v-on="on"></v-text-field>
                </template>
                <v-date-picker v-model="quotation.pay_date" range></v-date-picker>
            </v-menu>

            <!--v-select label="Color" v-model="quotation.color" :items="colors"></v-select>

            <v-select label="Cancelado?" v-model="quotation.sale_status" :items="['cancelado', 'vendido', 'vencido']"></v-select>
   

            <v-select label="Activo/Finalizado" v-model="quotation.is_active" :items="[{value:true, text:'Activo'}, {value:false, text:'Finalizado'}]"></v-select-->

            <!--v-select label="En crédito" v-model="quotation.in_credit" item-value="value" item-text="text" :items="siyno"></v-select-->

            <!--v-select label="Requiere Autorización" v-model="quotation.needs_authorization" item-value="value" item-text="text" :items="siyno"></v-select-->
            
            <!--v-menu offset-y :close-on-content-click="closeDatePicker(quotation.promise_date)">
                <template v-slot:activator="{ on, attrs }">
                    <v-text-field clearable v-model="quotation.promise_date" label="Fecha Promesa" prepend-icon="mdi-calendar" v-bind="attrs" readonly v-on="on"></v-text-field>
                </template>
                <v-date-picker v-model="quotation.promise_date" range></v-date-picker>
            </v-menu-->

        </v-row>
        <v-card style="position:absolute; bottom:0; width:100%;" tile color="primary">
            <v-list-item link @click="filter()" dark>
                <v-list-item-content>
                    <strong>Filtrar (0)</strong>
                </v-list-item-content>
            </v-list-item>    
        </v-card>
    </v-container>
</template>

<script>
import axios from "axios"
export default {
    data: () => ({
        siyno:[{text:'Si', value:true}, {text:'No', value:false}],
        quotation:{
            id:'',
            influencer:'',
            brand:'',
            service:'',
            service_date:'',
            invoice:'',
            invoice_date:[],
            deadline_date:[],
            pay_date:[],
            created_between:[],
            user_id:'',
            peach_invoice_file:'',
            campaign:'',
            campaign_status:'',
        },
        entries:{influencers:'', brands:''},
        isLoadingBrands: false,
        isLoadingInfluencers: false,
        searchBrands:'',
        searchInfluencers:''
    }),
    watch: {
        searchInfluencers(val){
            if(val!=null){
                var link = ''
                if(this.currentUser.role == 'Talent Agent' || this.currentUser.role == 'Booking'){
                    link = '&filter[parent_id]=' + this.currentUser.id
                }
                //if (this.influencerLists?.length > 0) return
                if (this.isLoadingInfluencers) return
                this.isLoadingInfluencers = true
                axios.get(process.env.VUE_APP_BACKEND_ROUTE + 'api/v1/influencer/search?filter[social_networks]='+val+link)
                .then(res => {
                    if(this.entries.influencers?.length>0){
                        this.entries.influencers = this.entries.influencers.concat(res.data.data)
                    }else{
                        this.entries.influencers = res.data.data
                    }
                }).finally(() => (this.isLoadingInfluencers = false))
            }   
        },
        searchBrands(val){
            if (this.isLoadingBrand) return
            this.isLoadingBrand = true
            var filter = ''
            axios.get(process.env.VUE_APP_BACKEND_ROUTE + 'api/v1/brands?' + filter + "filter[name]=" + val)
            .then(res => {
                if(this.entries.brands?.length>0){
                    this.entries.brands = this.entries.brands.concat(res.data.data)
                }else{
                    this.entries.brands = res.data.data
                }
            }).finally(() => (this.isLoadingBrand = false))
        },
    },
    computed:{
        campaign_statuses(){
            return this.$store.state.campaign.campaign_statuses
        },
        currentUser(){
            return this.$store.state.currentUser.user;
        },
        userList(){
            return this.$store.state.user.salesman.map(id => {
                return{
                    id:id.id,
                    name:id.name + ' ' + id.last,
                }
            })
        },
        influencerLists(){
            if(this.entries.influencers!=''){
                var perro = this.entries.influencers.map(id=>{
                    return{
                        id:id.id,
                        name: id.social_networks.instagram,
                        is_booking: id.is_booking
                    }
                })
                return perro
            }
        },
        brandLists(){
            if(this.entries.brands!=''){
                return this.entries.brands.map(id => {
                    return{
                        id:id.id,
                        name:id.name,
                        agency:id.agency
                    }
                })
            }
        },
    },
    created(){
        if(localStorage.getItem('selectorFiltersSales')!=undefined){
            this.quotation = JSON.parse(localStorage.getItem('selectorFiltersSales'))
            this.entries = JSON.parse(localStorage.getItem('entriesFiltersSales'))
        }
    },
    methods:{
        permissions(permission){
            if(this.currentUser.id==1){
                return true
            }else if(this.currentUser.permissions!=undefined){
                if(this.currentUser.permissions.includes(permission)){
                    return true
                }else{
                    return false
                }
            }else{
                return false
            }
        },
        closeDatePicker(dates){
            if(dates!=null && dates?.length==2){
                return true
            }else{
                return false
            }
        },
        removeFilter(){
            this.quotation = {
            id:'',
            influencer:'',
            brand:'',
            service:'',
            service_date:'',
            invoice:'',
            invoice_date:[],
            deadline_date:[],
            pay_date:[],
            created_between:[],
            user_id:'',
            peach_invoice_file:'',
            campaign:'',
            campaign_status:'',
        },
            this.$nextTick(() => {
                this.$emit("filtersQuotation", this.quotation);
            })
            this.entries.brands = []
            this.entries.influencers = []
            localStorage.removeItem("selectorFiltersSales")
            localStorage.removeItem("filtersSales")
            localStorage.removeItem("entriesFiltersSales")
            localStorage.removeItem("filtersSalesLength")
            this.$nextTick(() => {
                this.$store.dispatch('quotation/getTotals')
                this.$emit("filtersSale", false);
            })
        },
        filter(){
            var count = 0
            var filter = ''
            if(this.quotation.id!=''){
                count = count+1
                filter = filter + '&filter[id]='+this.quotation.id
            }
            if(this.quotation.influencer?.length>0){
                count = count+1
                filter = filter + '&filter[influencer_id]='
                var length = this.quotation.influencer?.length
                for(var i=0; i<length; i++){
                    filter = filter + this.quotation.influencer[i]
                    if(length>1 && i<length-1){
                        filter = filter + ','
                    }
                }
            }
            if(this.quotation.campaign_status!=''){
                count = count+1
                filter = filter + '&filter[campaign_status]=' + this.quotation.campaign_status
            }
            if(this.quotation.brand?.length>0){
                count = count+1
                filter = filter + '&filter[brand_id]='
                var length = this.quotation.brand?.length
                for(var i=0; i<length; i++){
                    filter = filter + this.quotation.brand[i]
                    if(length>1 && i<length-1){
                        filter = filter + ','
                    }
                }
            }
            if(this.quotation.campaign!=''){
                count = count+1
                filter = filter + '&filter[campaign]='+this.quotation.campaign
            }
            if(this.quotation.service!=''){
                count = count+1
                filter = filter + '&filter[services]='+this.quotation.service
            }
            if(this.quotation.service_date!=''){
                count = count+1
                filter = filter + '&filter[service_date]=' + this.quotation.service_date
            }
            if(this.quotation.user_id?.length>0){
                count = count+1
                filter = filter + '&filter[user_id]='
                var length = this.quotation.user_id?.length
                for(var i=0; i<length; i++){
                    filter = filter + this.quotation.user_id[i]
                    if(length>1 && i<length-1){
                        filter = filter + ','
                    }
                }
            }
            if(this.quotation.created_between?.length==2){
                count = count+1
                filter = filter + '&filter[created_between]=' + this.quotation.created_between[0] + ',' + this.quotation.created_between[1]
            }
            if(this.quotation.invoice!=''){
                count = count+1
                filter = filter + '&filter[invoice]='+this.quotation.invoice
            }
            if(this.quotation.peach_invoice_file!==''){
                count = count+1
                if(this.quotation.peach_invoice_file){
                    filter = filter + '&filter[has_peach_invoice_file]=1'
                }else{
                    filter = filter + '&filter[does_not_have_peach_invoice_file]=1'
                }
            }
            if(this.quotation.invoice_date?.length==2){
                count = count+1
                filter = filter + '&filter[invoice_date_between]=' + this.quotation.invoice_date[0] + ',' + this.quotation.invoice_date[1]
            }
            if(this.quotation.deadline_date?.length==2){
                count = count+1
                filter = filter + '&filter[deadline_date_between]=' + this.quotation.deadline_date[0] + ',' + this.quotation.deadline_date[1]
            }
            if(this.quotation.pay_date?.length==2){
                count = count+1
                filter = filter + '&filter[pay_date_between]=' + this.quotation.pay_date[0] + ',' + this.quotation.pay_date[1]
            }
            localStorage.setItem('selectorFiltersSales', JSON.stringify(this.quotation));
            localStorage.setItem('entriesFiltersSales', JSON.stringify(this.entries));
            localStorage.setItem('filtersSales', JSON.stringify(filter.slice(1,filter?.length)));
            localStorage.setItem('filtersSalesLength', count)
            this.$nextTick(() => {
                this.$emit("filtersQuotation", false);
                this.$store.dispatch('quotation/getTotals')
            })
        }
    }
}
</script>

<style>
.v-text-field {
    padding-top: 10px;
    margin-top: 0px;
}
</style>



